import React, { useState } from "react";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Divider from "@mui/material/Divider";

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontSize: '0.9375rem',
    fontFamily: '"Source Sans Pro",sans-serif',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  tabPanelRoot: {
    padding: 0,
  },
}));

const getDefaultTab = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  if (permis.includes("users_update")) {
    return "0";
  } else if (permis.includes("view_update")) {
    return "2";
  }
};

export default function UtilisateursTabs(props) {
  const currentusertype = localStorage.getItem('userType');
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const memv2versionactive = localStorage.getItem("memv2version");
  const classes = useStyles();
  const [value, setValue] = useState(getDefaultTab());

  const handleChange = (event, newValue) => {
    setValue(newValue);
    console.log(newValue);
  };

  return (
    <>

      <TabContext value={value} className={classes.root}>
        <div className={classes.demo2}>
          <AppBar
            position="static"
            className={classes.demo3}
            style={{ boxShadow: "none", shadowColor: "red" }}
          >
            <StyledTabs
              value={value}
              onChange={handleChange}
              aria-label="styled tabs example"
              scrollButtons="auto"
            >
              <StyledTab label="Utilisateurs" value="0" />
              <StyledTab label="Permissions" value="1" />
              {(memv2versionactive > 0 && permis.includes("view_update")) ? (
                  <StyledTab label="Vues" value="2" />
              ) : (
                <></>
              )}
              {(currentusertype == 1 && memv2versionactive > 0 && permis.includes("charts_access")) ? (
                  <StyledTab label="Graphiques" value="3" />
              ) : (
                <></>
              )}
            </StyledTabs>
            <Typography className={classes.padding} />
          </AppBar>
          <Divider variant="fullWidth" />

          <TabPanel value="0" classes={{ root: classes.tabPanelRoot }}>
            {props.utilisateurs}
          </TabPanel>
          <TabPanel value="1" classes={{ root: classes.tabPanelRoot }}>
            {props.permissions}
          </TabPanel>
          <TabPanel value="2" classes={{ root: classes.tabPanelRoot }}>
            {props.vues}
          </TabPanel>
          <TabPanel value="3" classes={{ root: classes.tabPanelRoot }}>
            {props.charts}
          </TabPanel>

          {" "}
        </div>
      </TabContext>
    </>
  );
}
